(function($) {
  function updateCartItem(p_options) {
    return new Promise(function(resolve, reject) {
      var data = {};

      if (p_options.quantity !== undefined) {
        data.quantity = p_options.quantity;
      }
      if (p_options.variant_id !== undefined) {
        data.id = p_options.variant_id;
      }
      if (p_options.key !== undefined) {
        data.id = p_options.key;
      }
      if (p_options.properties !== undefined) {
        data['properties'] = p_options.properties
      }
      console.log({update_cart_item: data});

      var api_type = p_options.api_type || 'change';
      var cart_api_url = '/cart/' + api_type + '.js';

      $.post(cart_api_url, data, null, 'json')
      .done(function(cart) {
        resolve(cart);
      })
      .fail(function(error) {
        console.error(error);
      });
    });
  }  
  
  function subscriptionModule() {
    // init select dropdown
    $('.product-select').select2();
    
    function getCurrentProduct($subscriptionModule) {
      if (!collections) {
        console.error('No Collections found.. Check codes');
      }
      
      var product_id = $subscriptionModule.find('.product-select').val();
      var product_type = $subscriptionModule.data('product-type');
      var collection = collections.find(function(collection) {
        return collection.handle == product_type;
      });
          
      var selected_product = collection.products.find(function(product) {
        return product.id == product_id;
      });
      
      return selected_product;
    }
    
    function getCurrentVariant($subscriptionModule) {
      var $product = $subscriptionModule.find('.product-single__form:not(.dn)');
      var selected_options = $product.find('select.option-selector option:selected').map(function(index, option) {
        return option.value;
      }).toArray();
      var product = getCurrentProduct($subscriptionModule);
      var variant = product.variants.find(function(variant) {
        return selected_options.join('|') == variant.options.join('|');
      });
      
      return variant;
    }
    
    function updateProduct($subscriptionModule) {
      var product = getCurrentProduct($subscriptionModule);
      var variant = getCurrentVariant($subscriptionModule);
      var $product_form = $subscriptionModule.find('#product_form_' + product.id);      
      
      function updateSubscribeButton() {
        var $button = $('.section--subscription-module .js-product-add');

        var isSoldout = !variant.available;

        $button.text(isSoldout ? 'Sold Out' : 'Subscribe Now');
        $button.prop('disabled', isSoldout);
      }

      function updateSelectedVariantId() {
        $product_form.find('input[name=id]').val(variant.subscriptions.discount_variant_id);
      }

      function updateProductImage() {
        var img_src = variant.featured_image ? variant.featured_image.src : product.featured_image.src;
        var $product_image = $subscriptionModule.find('.featured-image-wrap img');
        $product_image.attr('src', img_src);      
      }
     
      function updateTitle() {
        let option = $('.product-select.select2-hidden-accessible option:selected').attr('data-short-title');
        $(".product-featured__details .section__title-text.product-featured__title-text").text(option);  
      }

      function updateProductPrice() {
        var quantity = $product_form.find('.js-qty__num').val() || 1;
        var variant_price_formatted = Shopify.formatMoney(variant.price * quantity, Shopify.money_format);
        var variant_subscription_price_formatted = '$' + (variant.subscriptions.discount_variant_price * quantity).toFixed(2);
        
        $subscriptionModule.find('.variant-price').text(variant_price_formatted);
        $subscriptionModule.find('.variant-subscription-price').text(variant_subscription_price_formatted);
        console.log(quantity);
		console.log(variant_price_formatted);	
		console.log(variant_subscription_price_formatted);
		console.log(variant.price);
		console.log(variant);
		console.log(variant.subscriptions);
		console.log(variant.subscriptions.discount_variant_price);

      }
      
      updateSubscribeButton();
      updateSelectedVariantId();
      updateProductImage();
      updateTitle();
      updateProductPrice();
    }    
    
    // product change
    $(document).on('change', '.section--subscription-module .product-select', function(e) {
      var $select = $(e.currentTarget);
      var $subscriptionModule = $select.closest('.section--subscription-module');
      var product_id = $select.val();
      var $product_form = $subscriptionModule.find('#product_form_' + product_id);
      
      $subscriptionModule.find('.product-single__form').addClass('dn');
      $product_form.removeClass('dn');
      
      updateProduct($subscriptionModule);
    });
    
    // variant change
    $(document).on('change', '.section--subscription-module .option-selector', function(e) {
      var $subscriptionModule = $(e.currentTarget).closest('.section--subscription-module');
      updateProduct($subscriptionModule);
    });
    
    // quantity change
    $(document).on('click', '.section--subscription-module .js-qty__adjust', function(e) {
      setTimeout(function() {
        var $quantity_container = $(e.target).closest('.product-single__qty');
        var $quantity = $quantity_container.find('.js-qty__num');
        var $quantity_pack = $quantity_container.find('.quantity-pack');
        var $subscriptionModule = $quantity_container.closest('.section--subscription-module');        
        
        var qty = $quantity.val();
        var text = qty + ' Pack' + ((qty == 1) ? '' : 's');
        $quantity_pack.text(text);
        
        updateProduct($subscriptionModule);
      }, 100);
    });
    
    // Add to cart
    $(document).on('click', '.section--subscription-module .js-product-add', function(e) {
      e.preventDefault();
      
      var $atcButton = $(e.currentTarget);
      var $subscriptionModule = $atcButton.closest('.section--subscription-module');
      var product = getCurrentProduct($subscriptionModule);
      var $form = $('#product_form_' + product.id);
      
      $form.submit();
    });
  }
  
  function reasonsCarousel() {
    var selector = '.list-reasons';
    var slick_options = {
      infinite: false,
      slidesToShow: 1.5,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 601,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1
          }
        }
      ]
    };
    
    function initCarousel() {
      var isMobile = window.matchMedia("(max-width: 950px)").matches;
      if (isMobile) {
        $(selector).slick(slick_options);
      }
      else {
        var slickInitialized = $(selector + '.slick-initialized').length !== 0;
        if (slickInitialized) {
          $(selector).slick('destroy');
        }
      }
    }
    
    setTimeout(initCarousel, 500);
    $(window).resize(function() {
      setTimeout(initCarousel, 500);
    });
  }
  
  function nutritionsCarousel() {
    var selector = '.list-nutritions';
    var slick_options = {
      infinite: false,
      slidesToShow: 1.5,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 479,
          settings: {
            slidesToShow: 1.15,
            slidesToScroll: 1
          }
        }
      ]
    };
    
    function adjustBlockHeights() {
      var $section = $('.list-nutritions');
      $section.find('.nutrition-block-wrap').each(function() {
        var $wrap = $(this);
        $wrap.css('height', $section.height())
      });      
    }
    
    function initCarousel() {
      var isMobile = window.matchMedia("(max-width: 900px)").matches;
      
      if (isMobile) {
        $(selector).on('init', function(e) {
          setTimeout(adjustBlockHeights, 0);
        });
        $(selector).slick(slick_options);
      }
      else {
        var slickInitialized = $(selector + '.slick-initialized').length !== 0;
        if (slickInitialized) {
          $(selector).slick('destroy');
        }
        setTimeout(adjustBlockHeights, 0);
      }
    }
    
    setTimeout(initCarousel, 500);
    $(window).resize(function() {
      setTimeout(initCarousel, 500);
    });
  }  
  
  function subscribeBtnScroll() {
    $(document).on('click', '[data-scroll-to]', function(e) {
      e.preventDefault();
      var $btn = $(e.currentTarget);
      var scrollTo = $btn.data('scroll-to');
      
      var targetOffset = $('#' + scrollTo).offset().top;
      $('html,body').animate({scrollTop: targetOffset}, 1000);      
    });
  }
  
  $(document).ready(function() {
    reasonsCarousel();
    nutritionsCarousel();
    subscriptionModule();
    subscribeBtnScroll();
  });
})(jQuery);